import { lazy } from "react";

export const LazyDashboard = lazy(() => import("../../Pages/Dashboard"));

export const LazyDoors = lazy(() => import("../../Pages/Doors"));

export const LazyDetailDoor = lazy(() => import("../../Pages/Doors/DetailDoor"));

export const LazyCameras = lazy(() => import("../../Pages/Cameras"));

export const LazyHubs = lazy(() => import("../../Pages/Hubs"));

export const LazyDetailHub = lazy(() => import("../../Pages/Hubs/DetailHubs"));

export const LazyDetailCamera = lazy(() => import("../../Pages/Cameras/DetailCameras"));

export const LazySettings = lazy(() => import("../../Pages/Settings"));

export const LazyLogs = lazy(() => import("../../Pages/Logs"));

export const LazyLicenseLogs = lazy(() => import("../../Pages/LicenseLogs"));

export const LazyUsers = lazy(() => import("../../Pages/Users"));

export const LazyDetailUser = lazy(() => import("../../Pages/Users/DetailUser"));

export const LazySupportUser = lazy(() => import("../../Pages/SupportUsers/index"));

export const LazySupportUserDetail = lazy(
  () => import("../../Pages/SupportUsers/SupportUserDetail")
);

export const LazyCustomerRequests = lazy(() => import("../../Pages/CustomerRequests"));

export const LazyPartner = lazy(() => import("../../Pages/Partner"));

export const LazyShipping = lazy(() => import("../../Pages/Shipping"));

export const LazySensors = lazy(() => import("../../Pages/Sensors"));
export const LazyDetailSensor = lazy(() => import("../../Pages/Sensors/DetailSensor"));

export const LazyAccountDeviceSubscription = lazy(
  () => import("../../Pages/AccountDeviceSubscription")
);

export const LazyGateway = lazy(() => import("../../Pages/Gateway"));
export const LazyDetailAppliances = lazy(() => import("../../Pages/Gateway/AppliancesDetails"));
